import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartItemComponent } from './cart/cart-item/cart-item.component';
import { UnavailableCartItemComponent } from './cart/unavailable-cart-item/unavailable-cart-item.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { FavouritesModule } from '../favourites/favourites.module';
import { CartManageSamplingMenuComponent } from './cart/cart-manage-sampling-menu/cart-manage-sampling-menu.component';
import { CartManageSamplingComponent } from './cart/cart-manage-sampling/cart-manage-sampling.component';
import { SharedModule } from '../shared';
import { FavouritesBadgeComponent } from '../favourites/containers/favourites-badge/favourites-badge.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
// import { NgxAnalyticsModule } from 'ngx-analytics';

@NgModule({
    imports: [
        CommonModule,
        FavouritesModule,
        SharedModule,
        NzDropDownModule
    ],
    declarations: [
    // customer portal components
        CartManageSamplingMenuComponent,
        CartManageSamplingComponent,
        OrderSummaryComponent,
        CartItemComponent,
        UnavailableCartItemComponent
    ],
    exports: [
    // customer portal components
        CartManageSamplingComponent,
        CartManageSamplingMenuComponent,
        OrderSummaryComponent,
        CartItemComponent,
        UnavailableCartItemComponent
    ]
})
export class SharedCartFavouritesLinkModule { }
